import { gql } from "@apollo/client";

const QUERY_USER_PRODUCT_BY_TOKEN = gql`
  query FindUserProductByToken(
    $associationType: AssociationType!
    $inviteConfirmationToken: String!
  ) {
    findUserProductByToken(
      associationType: $associationType
      inviteConfirmationToken: $inviteConfirmationToken
    ) {
      _id
      inviteStatus
    }
  }
`;

const FIND_USER_PRODUCTS_BY_USER = gql`
  query FindUserProductByUserId {
    findUserProductByUserId {
      _id
      associationType
      product {
        ... on DafProduct {
          _id
          name
        }
        ... on CommunityFundProduct {
          _id
          name
        }
        ... on ClatProduct {
          _id
          name
        }
        ... on BrandingProduct {
          _id
          name
        }
      }
    }
  }
`;

const FIND_PRODUCT_OWNER = gql`
  query FindProductOwner($productId: ID!) {
    findProductOwner(productId: $productId) {
      _id
      user {
        ... on DonorUser {
          _id
          firstName
          lastName
        }
      }
    }
  }
`;

const FIND_PRODUCTS_FOR_LINKING = gql`
  query FindProductsForLinking($userId: ID!) {
    findProductsForLinking(userId: $userId) {
      ... on DafProduct { _id name productStatus }
      ... on ClatProduct { _id name productStatus }
      ... on BrandingProduct { _id name productStatus }
      ... on CommunityFundProduct { _id name productStatus }
    }
  }
`;

export { QUERY_USER_PRODUCT_BY_TOKEN, FIND_USER_PRODUCTS_BY_USER, FIND_PRODUCT_OWNER, FIND_PRODUCTS_FOR_LINKING };
